import React from "react";
import CloseIcon from "./PillCloseIcon";
import { noop } from "@/util/common";
import {
  PillContainer,
  PillCloseIconWrapper,
  PillValueInput,
  PillValueInputWrapper,
  PillValueStatic,
  PillValueDummyText,
  PillValueContainer,
} from "./Pill.styled";

const Pill = ({
  valueDescription,
  value,
  onDelete,
  editable,
  isError,
  onChange = noop,
  onBlur = noop,
}) => {
  return (
    <PillContainer isError={isError}>
      <div>{`${valueDescription}: `}</div>
      {editable ? (
        <PillValueContainer>
          <PillValueDummyText>{value}</PillValueDummyText>
          <PillValueInputWrapper>
            <PillValueInput
              type="text"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
            />
          </PillValueInputWrapper>
        </PillValueContainer>
      ) : (
        <PillValueStatic>{value}</PillValueStatic>
      )}
      <PillCloseIconWrapper
        onClick={(evt) => {
          evt.stopPropagation();
          onDelete(evt);
        }}
      >
        <CloseIcon />
      </PillCloseIconWrapper>
    </PillContainer>
  );
};

export default Pill;
